export default function updateAction(state, payload) {
  return {
    ...state,
    stroj: {
      ...state.stroj,
      ...payload,
    },
  };
}
